<footer>
  <div class="left-group">
    <img src="assets/images/logo-footer.png" style="height: 25px;">
    <div class="copyright">
      © Awair 2017
    </div>
    <div class="contact-us">
      <a href="mailto:hello@getawair.com">Contact Us</a>
    </div>
  </div>
</footer>
